import { Batch } from './batch';
import { HttpRequest } from './httpRequest';
export function startBatchWithReplica(configuration, endpoint, replicaEndpoint) {
  var primaryBatch = createBatch(endpoint);
  var replicaBatch;

  if (replicaEndpoint) {
    replicaBatch = createBatch(replicaEndpoint);
  }

  function createBatch(endpointBuilder) {
    return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout);
  }

  return {
    add: function add(message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }

      primaryBatch.add(message);

      if (replicaBatch && replicated) {
        replicaBatch.add(message);
      }
    }
  };
}